import script from "./AdminStreamsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminStreamsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminStreamsPage.vue?vue&type=style&index=0&id=50196bfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50196bfc"]])

export default __exports__